<template lang="pug">
	section#educacao
		div.wrapper
			div.conteudo
				h2
					|Educação de qualidade é um direito de todos.
				p
					|A
					strong UniFAEL
					|sabe da imensa adaptação que os docentes de todo Brasil estão enfrentando para desempenhar
					|suas funções, trocando a sala de aula pela tecnologia tão rapidamente. Por isso, quer contribuir
					|com técnicas, processos e métodos eficazes para que você, professor e profissional da educação,
					|possa levar aos milhões de alunos um ensino online de qualidade, afinal o aprendizado não pode parar.
					|A educação é um direito de todos e somente através dela é que podemos formar cidadãos melhores.
</template>

<script>
export default {
	name: "section-educacao"
}
</script>

<style lang="stylus" scoped src="./Educacao.styl"></style>
